import api from "./axiosConfig";
import { ENVIRO_ENDPOINT } from "./apiEndpoints";
import { logError } from "./errorLogService";

export const fetchEnviro = async (retryCount = 1) => {
  try {
    const response = await api.get(ENVIRO_ENDPOINT(), {
      params: { _t: Date.now() },
    });
    return response.data;
  } catch (error) {
    const isTimeout = error.code === "ECONNABORTED" || error.message?.includes("timeout");
    const isNetworkError = !error.response && error.request;

    if ((isTimeout || isNetworkError) && retryCount > 0) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return fetchEnviro(retryCount - 1);
    }

    console.error("Error fetching Enviro data", error);

    await logError("enviro_data_fetch", error, {
      endpoint: ENVIRO_ENDPOINT(),
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    return null;
  }
};
